"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardFormPublicController = void 0;
var tslib_1 = require("tslib");
var PaymentProvider_1 = require("@wix/cashier-common/dist/src/enums/payments/PaymentProvider");
var apiRoutes_1 = require("@wix/cashier-core/dist/src/utils/apiRoutes");
var headers_1 = require("@wix/headers");
var qs = require("qs");
var React = require("react");
var OutboundEventName_1 = require("../../types/OutboundEventName");
var InteractionName_1 = require("../../types/InteractionName");
var InboundMessageType_1 = require("../../types/InboundMessageType");
var OutboundMessageType_1 = require("../../types/OutboundMessageType");
var errorReporter_1 = require("../../utils/errorReporter");
var fedopsLogger_1 = require("../../utils/fedopsLogger");
var emitMessage_1 = require("../../utils/messages/emitMessage");
var replyToMessage_1 = require("../../utils/messages/replyToMessage");
var window_1 = require("../../utils/window");
var constants_1 = require("./constants");
var view_1 = require("./view");
var CardFormPublicController = /** @class */ (function (_super) {
    tslib_1.__extends(CardFormPublicController, _super);
    function CardFormPublicController(props) {
        var _this = _super.call(this, props) || this;
        _this.iframeRef = React.createRef();
        // can't use performance.now() because startLoadTime will be passed to a different frame
        _this.startLoadTime = Date.now();
        _this.isConfigSent = false;
        _this.returnAPI = function () {
            try {
                _this.props.onApiInit({
                    validate: function () {
                        return _this.emitMessage(InboundMessageType_1.InboundMessageType.Validate);
                    },
                    getPublicData: function () {
                        return _this.emitMessage(InboundMessageType_1.InboundMessageType.GetPublicData);
                    },
                    tokenize: function (params) {
                        return _this.emitMessage(InboundMessageType_1.InboundMessageType.Tokenize, tslib_1.__assign(tslib_1.__assign({}, params), { additionalHeaders: headers_1.createHeaders() }), true);
                    },
                    save: function (params) {
                        return _this.emitMessage(InboundMessageType_1.InboundMessageType.Save, params, true);
                    },
                    update: function (params) {
                        return _this.emitMessage(InboundMessageType_1.InboundMessageType.Update, params, true);
                    },
                    focusInvalidField: function (params) {
                        return _this.emitMessage(InboundMessageType_1.InboundMessageType.FocusInvalidField, params);
                    },
                });
            }
            catch (error) {
                console.error("CardForm: onApiInit failed to execute", error);
            }
        };
        _this.reportCrash = function (message, shouldCapture) {
            _this.props.reportCrash(message, shouldCapture);
            if (_this.clearReadyAwaiter !== null) {
                _this.clearReadyAwaiter();
                _this.clearReadyAwaiter = null;
            }
        };
        _this.buildConfig = function () {
            return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ country: _this.props.country, appId: _this.props.appId, appInstanceId: _this.props.appInstanceId, deviceType: _this.props.deviceType }, (_this.props.theme && {
                theme: _this.props.theme,
            })), (_this.props.savedCard && {
                savedCard: _this.props.savedCard,
            })), (_this.props.orderId && {
                orderId: _this.props.orderId,
            })), (_this.props.providerId === PaymentProvider_1.PaymentProvider.Square &&
                _this.props.squareAppId && {
                squareAppId: _this.props.squareAppId,
            })), (_this.props.providerId === PaymentProvider_1.PaymentProvider.TwoCheckout &&
                _this.props.sellerId &&
                _this.props.publishableKey && {
                sellerId: _this.props.sellerId,
                publishableKey: _this.props.publishableKey,
            })), (_this.props.apiBaseURLOverride && {
                apiBaseURLOverride: _this.props.apiBaseURLOverride,
            }));
        };
        _this.buildUrl = function () {
            var query = tslib_1.__assign({ locale: _this.props.locale, providerId: _this.props.providerId, parentOrigin: window_1.win.location.origin, startLoadTime: String(_this.startLoadTime), msid: _this.props.msid, visitorId: _this.props.visitorId, siteOwnerId: _this.props.siteOwnerId }, _this.props.consentPolicyHeader);
            var separator = _this.formBaseURL.includes('?') ? '&' : '?';
            return _this.formBaseURL + separator + qs.stringify(query);
        };
        _this.handleFormReady = function () {
            fedopsLogger_1.fedopsLogger.interactionEnded(InteractionName_1.InteractionName.ALE);
            _this.clearReadyAwaiter();
            _this.returnAPI();
            if (_this.props.onLoad) {
                try {
                    _this.props.onLoad();
                }
                catch (error) {
                    console.error("CardForm: onLoad failed to execute", error);
                }
            }
        };
        _this.handlePostMessage = errorReporter_1.captureIfThrows(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (event.source !== this.iframeWindow ||
                            event.origin !== this.formOrigin ||
                            !event.data ||
                            this.isLoadFailed) {
                            return [2 /*return*/];
                        }
                        if (!event.data.event) return [3 /*break*/, 1];
                        switch (event.data.event) {
                            case OutboundEventName_1.OutboundEventName.Ready:
                                this.updateSizes(event.data.payload.sizes, this.handleFormReady);
                                break;
                            case OutboundEventName_1.OutboundEventName.Change:
                                if (this.props.onChange) {
                                    try {
                                        this.props.onChange(event.data.payload);
                                    }
                                    catch (error) {
                                        console.error("CardForm: onChange failed to execute", error);
                                    }
                                }
                                break;
                            case OutboundEventName_1.OutboundEventName.SizeChange:
                                this.updateSizes(event.data.payload);
                                break;
                            case OutboundEventName_1.OutboundEventName.Crash:
                                this.reportCrash(event.data.payload, false);
                                break;
                            default:
                        }
                        return [3 /*break*/, 5];
                    case 1:
                        if (!(event.data.messageId && event.data.payload)) return [3 /*break*/, 5];
                        _a = event.data.payload.type;
                        switch (_a) {
                            case OutboundMessageType_1.OutboundMessageType.GetConfig: return [3 /*break*/, 2];
                            case OutboundMessageType_1.OutboundMessageType.GetNewAppInstance: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 2:
                        replyToMessage_1.replyToMessage(event, this.buildConfig());
                        this.isConfigSent = true;
                        return [3 /*break*/, 5];
                    case 3:
                        _b = replyToMessage_1.replyToMessage;
                        _c = [event];
                        return [4 /*yield*/, this.props.revalidateAppInstance()];
                    case 4:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }, "Failed to handle outbound post message.");
        _this.updateSizes = function (_a, cb) {
            var height = _a.height;
            if (height && _this.state.height !== height) {
                _this.setState({ height: height }, cb);
            }
            else if (cb) {
                cb();
            }
        };
        _this.emitMessage = function (type, data, isSlowMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var interaction, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        switch (type) {
                            case InboundMessageType_1.InboundMessageType.Tokenize:
                                interaction = InteractionName_1.InteractionName.API_TOKENIZE;
                                break;
                            case InboundMessageType_1.InboundMessageType.Save:
                                interaction = InteractionName_1.InteractionName.API_SAVE;
                                break;
                            case InboundMessageType_1.InboundMessageType.Update:
                                interaction = InteractionName_1.InteractionName.API_UPDATE;
                                break;
                            case InboundMessageType_1.InboundMessageType.Validate:
                                interaction = InteractionName_1.InteractionName.API_VALIDATE;
                                break;
                            case InboundMessageType_1.InboundMessageType.GetPublicData:
                                interaction = InteractionName_1.InteractionName.API_GET_PUBLIC_DATA;
                                break;
                            default:
                        }
                        if (interaction) {
                            fedopsLogger_1.fedopsLogger.interactionStarted(interaction);
                        }
                        return [4 /*yield*/, emitMessage_1.emitMessage(tslib_1.__assign({ type: type }, (data && { data: data })), this.iframeWindow, this.formOrigin, isSlowMessage)];
                    case 1:
                        result = _a.sent();
                        if (interaction) {
                            fedopsLogger_1.fedopsLogger.interactionEnded(interaction);
                        }
                        return [2 /*return*/, result];
                }
            });
        }); };
        _this.state = {
            // at this stage the height of form content is unknown, thus rendering it with some predefined
            // size at first, and then update to real sizes upon Ready event, and listen to SizeChange event
            height: '200',
        };
        try {
            _this.startReadyAwaiter();
            _this.url = _this.buildUrl(); // should be built once upon mount, it can't be changed dynamically
        }
        catch (error) {
            _this.reportCrash(error);
        }
        return _this;
    }
    CardFormPublicController.prototype.componentDidMount = function () {
        window_1.win.addEventListener('message', this.handlePostMessage);
    };
    CardFormPublicController.prototype.componentDidUpdate = function (prevProps) {
        var _a;
        if (prevProps.savedCard &&
            !prevProps.savedCard.withCVV && ((_a = this.props.savedCard) === null || _a === void 0 ? void 0 : _a.withCVV) &&
            this.isConfigSent) {
            this.emitMessage(InboundMessageType_1.InboundMessageType.ForceShowSavedCardCVV);
        }
    };
    CardFormPublicController.prototype.componentWillUnmount = function () {
        window_1.win.removeEventListener('message', this.handlePostMessage);
        this.clearReadyAwaiter && this.clearReadyAwaiter();
    };
    CardFormPublicController.prototype.startReadyAwaiter = function () {
        var _this = this;
        var timeoutHandler = setTimeout(function () {
            _this.reportCrash("load timeout", false);
        }, constants_1.maxReadyTimeout);
        this.clearReadyAwaiter = function () {
            clearTimeout(timeoutHandler);
        };
    };
    Object.defineProperty(CardFormPublicController.prototype, "isLoadFailed", {
        get: function () {
            return this.clearReadyAwaiter === null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardFormPublicController.prototype, "iframeWindow", {
        get: function () {
            var _a;
            if (!((_a = this.iframeRef) === null || _a === void 0 ? void 0 : _a.current)) {
                console.warn("CardForm: iframe HTML Element wasn't found. Was it already unmounted?");
                return;
            }
            return this.iframeRef.current.contentWindow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardFormPublicController.prototype, "formBaseURL", {
        get: function () {
            if (this.props.baseURLOverride) {
                return this.props.baseURLOverride;
            }
            var origin = apiRoutes_1.pciOrigin;
            // PAY-2641. Broken layout in Android if iframe origin differs from parent's frame origin
            if (/Android/i.test(window_1.win.navigator.userAgent) &&
                window_1.win.location.origin.endsWith('.wix.com')) {
                origin = apiRoutes_1.oldPciOrigin;
            }
            return origin + "/" + constants_1.formPathname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardFormPublicController.prototype, "formOrigin", {
        get: function () {
            return new URL(this.formBaseURL).origin;
        },
        enumerable: false,
        configurable: true
    });
    CardFormPublicController.prototype.render = function () {
        return (React.createElement(view_1.CardFormPublicView, { url: this.url, iframeRef: this.iframeRef, height: this.state.height }));
    };
    return CardFormPublicController;
}(React.Component));
exports.CardFormPublicController = CardFormPublicController;
//# sourceMappingURL=controller.js.map